<template>
    <div class="c-product-variation-line c-product-line" :class="{'pim-disabled': product.IsPIMDisabled}"
        :title="[product.IsPIMDisabled ? $t('product.thumb.pim_disabled', {color: product.ColorId + ' ' + product.Color}) : '']">
        <v-product-delete @change="removeProduct" title="product.variation_thumb.delete"></v-product-delete>

        <strong class="u-color-alpha-base">{{ product.Name }}</strong>

        <div class="grid">
            <div class="c-product-color">
                <div class="c-product-color-element" :style="`background-color: ${product.HexCode}`"></div>
                <p class="c-product-color-info">
                    <strong>Kleur: {{ product.ColorId }} {{ product.Color }}</strong>
                </p>
            </div>

            <div class="u-padding-left-large">
                <v-input v-model.number="product.MaximumDiscount"
                         input-size="tiny"
                         :max=100 :min=0
                         type="number"
                         width="50px"
                         :name="`${_uid}_variation_max_discount`"
                         @change="updateProduct">
                    <slot slot="label"><strong>Max korting:</strong></slot>
                </v-input>
            </div>

            <div>
                <v-input v-model.number="product.DefaultDiscount"
                         name="max_discount"
                         type="number"
                         :max=100
                         width="50px"
                         :min=0
                         input-size="tiny"
                         @change="updateProduct">
                    <slot slot="label"><strong>Standaard korting:</strong></slot>
                </v-input>
            </div>

            <div>
                <table class="c-product-info">
                    <tr>
                        <td><strong class="u-semi-bold">Aankoopprijs:</strong></td>
                        <td>{{ product.RetailFromPrice | currency(customerCurrencySymbol) }}</td>
                    </tr>
                    <tr>
                        <td><strong class="u-semi-bold">Adviesverkoopprijs:</strong></td>
                        <td>{{ product.OriginalFromPrice | currency(customerCurrencySymbol) }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="c-product-select-sizes">
            <v-product-size-toggle v-for="item in productSizes" :key="item.Id" :item.sync="item"></v-product-size-toggle>
        </div>
    </div>
</template>

<script>
    import debounce from 'lodash/debounce'
    import Toggle from '@/components/Toggle'
    import VSelect from '@/components/form/Select'
    import VInput from '@/components/form/Input'
    import VFilterCheckboxElement from '@/components/form/filters/FilterCheckboxElement'
    import VProductSizeInput from '@/components/product/widgets/productSizeInput'
    import VProductSizeToggle from '@/components/product/widgets/productSizeToggle'
    import VProductDelete from '@/components/product/widgets/productDelete'

    export default {
        props: {
            product: Object,
            parentId: String,
            groupIndex: Number,
            maxDiscountValue: Number,
            defaultDiscountValue: Number
        },
        components: {
            Toggle,
            VSelect,
            VInput,
            VFilterCheckboxElement,
            VProductSizeInput,
            VProductSizeToggle,
            VProductDelete
        },
        data() {
            return {
                productSizes: this.product.Variants
            }
        },
        watch: {
            maxDiscountValue() {
                this.product.MaximumDiscount = this.maxDiscountValue
                this.updateProduct();
            },
            defaultDiscountValue() {
                this.product.DefaultDiscount = this.defaultDiscountValue
                this.updateProduct();
            }
        },
        computed: {
            customerCurrencySymbol() { 
                return this.$store.getters.userInfo.customerCurrencySymbol;
            }
        },
        methods: {
            removeProduct() {
                this.$store.dispatch('deleteMarketingFromSheet', {
                    preOrderSheetId: this.parentId,
                    productId: this.product.Id,
                    groupIndex: this.groupIndex
                }).then(() => {
                    //Use parent because used in slot of ProductLineLayout
                    this.$parent.$emit('remove');
                });
            },
            updateProduct: debounce(function () {
                if(this.product.MaximumDiscount < this.product.DefaultDiscount)
                {
                    this.product.DefaultDiscount = this.product.MaximumDiscount;
                }

                this.$store.dispatch('updateMarketingInSheet', {
                    preOrderSheetId: this.parentId,
                    productId: this.product.Id,
                    body: {
                        Id: this.product.Id,
                        MaximumDiscount: this.product.MaximumDiscount,
                        DefaultDiscount: this.product.DefaultDiscount
                    }
                });
            }, 500),
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .pim-disabled {
        border: 4px solid $color-error;
        padding: 4px;
    }

</style>


// WEBPACK FOOTER //
// src/components/product/admin/MarketingVariationLine.vue